import { FC, PropsWithChildren, useContext, useEffect, useState } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { MainLayout, scrollToTop } from '../MainLayout';

import { AuthContext } from '../../contexts';

import { UserInformation } from '../../interfaces';
import { Loading, MaintenancePage } from '../../../pages';
import MasterService from '../../services/master';

interface PrivateWrapperProps extends PropsWithChildren {}

export const PrivateWrapper: FC<PrivateWrapperProps> = ({ children }) => {
  const authContext = useContext(AuthContext);
  const location = useLocation();

  const LOGIN_URL = '/login';
  const LOGOUT_URL = '/logout';
  const INTERMEDIARY_URL = '/seleccionar-intermediario';

  const [isCheckingStatus, setIsCheckingStatus] = useState<boolean>(false);
  const [isOnline, setIsOnline] = useState<boolean | null>(null);

  const resp = authContext.getUserInfo() as UserInformation | null;
  const isAuthenticated = resp != null;

  const hasIntermediary = resp?.intermediarioSecundario != null;

  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  useEffect(() => {
    const verifyServiceStatus = async () => {
      if (!isAuthenticated) {
        setIsCheckingStatus(false);
        setIsOnline(null);
        return;
      }

      try {
        setIsCheckingStatus(true);
        const online = await MasterService.getServiceStatus();
        setIsOnline(online);
      } finally {
        setIsCheckingStatus(false);
      }
    };

    verifyServiceStatus();
  }, [isAuthenticated]);

  if (location.pathname === LOGIN_URL || location.pathname === LOGOUT_URL) {
    return <Outlet />;
  }

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_URL} />;
  }

  if (isCheckingStatus || isOnline === null) {
    return <Loading />;
  }

  if (!isOnline) {
    return <MaintenancePage />;
  }

  if (!hasIntermediary && location.pathname !== INTERMEDIARY_URL) {
    return <Navigate to={INTERMEDIARY_URL} />;
  }

  return authContext.Productores ? (
    <MainLayout showBreadcrumb={children ? false : true}>
      {children ? (
        children
      ) : (
        <Outlet key={`${location.pathname}${location.search}`} />
      )}
    </MainLayout>
  ) : (
    <Loading />
  );
};
